import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { LoadState } from "../../../../../../constants/enums";
import { fetchHabitationalApplicationListAsync } from "../../../../../../redux/habitationalPolicy/habitationalApplication/habitationalApplication.Actions";
import { IHabitationalApplication } from "../../../../../../redux/habitationalPolicy/habitationalApplication/habitationalApplicationNew.types";

export const useHabitationalApplicationList = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const { list, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.habitational.applications
  );

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(
        fetchHabitationalApplicationListAsync(customerPolicyId)
      );
    }
  }, [customerPolicyId]);

  const applicationDropdown = React.useMemo(() => {
    if (loading === LoadState.InProgress) {
      return [{ label: "Loading...", value: "" }];
    }
    const options = list.map((item: IHabitationalApplication) => ({
      label: String(item.incremental_number),
      value: String(item.incremental_number),
    }));
    return [{ label: "NONE", value: "" }, ...options];
  }, [list, loading]);

  const defaultApplicationNumber: string = React.useMemo(() => {
    if (list.length === 0) return "";
    const incrementalNumbers = list.map((item: IHabitationalApplication) => item.incremental_number).filter((n): n is number => n !== null);
    if (incrementalNumbers.length === 0) return "";
    return String(Math.max(...incrementalNumbers));
  }, [list]);

  return { applicationDropdown, defaultApplicationNumber, loading };
};
